import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
export var lazySyncBlockView = function lazySyncBlockView(props) {
  return withLazyLoading({
    nodeName: 'syncBlock',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-synced-block-nodeview" */
      './syncedBlock').then(function (_ref) {
        var syncBlockNodeView = _ref.syncBlockNodeView;
        return syncBlockNodeView(props);
      });
      return result;
    }
  });
};